export default __webpack_public_path__ + "static/EngagingUnderservedCommunities-e0fb52e6601aba91330ccde0e16aafe1.png";